import React, { useMemo } from 'react'
import { ANYWHERE_PLACE_ID } from 'constants/search'
import { LOOKING_FOR_SOMETHING_ELSE_CONTENT } from '../LookingForSomethingElse/constants'
import { isManualSortingEnabledFor } from 'selectors/featuresSelectors'
import OfferCarouselLookingForSomethingElse from '../LookingForSomethingElse/OfferCarouselLookingForSomethingElse'
import OfferCardCarouselSection from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import Places from 'constants/places'
import { getToursOfferListFilters } from 'home/helpers'

interface Props {
  title?: React.ReactNode;
  excludedIds?: Array<string>;
}

function TourOfferCarousel(props: Props) {
  const { title, excludedIds } = props
  const isToursManualSortingEnabled = isManualSortingEnabledFor('tours')
  const offerListFilters = useMemo(() => getToursOfferListFilters(isToursManualSortingEnabled), [isToursManualSortingEnabled])
  const to = useMemo(() => {
    if (offerListFilters.destinationId && offerListFilters.destinationId !== ANYWHERE_PLACE_ID) {
      const query = {
        destinationId: offerListFilters.destinationId,
        destinationName: offerListFilters.destinationName ?? '',
      }
      return `/search/tours?${new URLSearchParams(query)}`
    }
    return LOOKING_FOR_SOMETHING_ELSE_CONTENT.tours.to
  }, [offerListFilters])

  return (
    <OfferCardCarouselSection
      filters={offerListFilters}
      title={title ?? <>Once-in-a-lifetime <i>tours</i></>}
      allLink="/tours"
      additionalFilters="tourLocations"
      defaultFilter={Places.Anywhere.id}
      tileStyle="card-medium"
      excludedIds={excludedIds}
      dataTestId="tours-carousel"
    >
      <OfferCarouselLookingForSomethingElse to={to} />
    </OfferCardCarouselSection>
  )
}

export default TourOfferCarousel
